import React from "react";
import {
  Box,
  Typography,
  Button,
  Container,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { ArrowRight, ArrowRightAlt } from "@mui/icons-material";

const Hero = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "100vh",
        backgroundImage: "url(/bg.webp)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        overflow: "hidden",
        borderRadius: 4,
        mx: { xs: 1, sm: 2 },
        alignItems: "center",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)", // Dark overlay for better text readability
          zIndex: 1,
        },
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          position: "relative",
          zIndex: 2,
          textAlign: { xs: "center", sm: "left" },
        }}
      >
        <Box
          sx={{
            maxWidth: { xs: "100%", sm: "600px", md: "700px" },
            color: "white",
          }}
        >
          {/* Main Heading */}
          <Typography
            variant="h1"
            component="h1"
            data-aos="fade-up"
            data-aos-delay="200"
            sx={{
              fontSize: {
                xs: "2.5rem",
                sm: "3.5rem",
                md: "4.5rem",
                lg: "5rem",
              },
              fontWeight: "bold",
              lineHeight: 1.1,
              fontFamily: "Monument-Private",
              mb: 2,
            }}
          >
            Aspire Ventures
          </Typography>

          {/* Subtitle */}
          <Typography
            variant="h4"
            component="h2"
            data-aos="fade-up"
            data-aos-delay="400"
            sx={{
              fontSize: { xs: "1.2rem", sm: "1.5rem" },

              mb: 4,
              color: "rgba(255, 255, 255, 0.9)",
            }}
          >
            Stays and Experiences in Goa
          </Typography>

          {/* Contact Button */}
          <Button
            variant="contained"
            color="secondary"
            size={isMobile ? "medium" : "large"}
            data-aos="fade-up"
            data-aos-delay="500"
            sx={{
              textTransform: "none",
              fontWeight: 600,
              px: 5,
              py: 2,
              fontSize: { xs: "1rem", sm: "1.1rem", md: "1.2rem" },
              transition: "all 0.3s ease",
              "&:hover": {
                transform: "translateY(-2px)",
              },
            }}
            onClick={() => window.location.assign("/contact")}
          >
            Contact Us
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default Hero;
